//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

import PublicPageFrame from '@/components/universal/layout/PublicPageFrame.vue'
import CodeInput from '@/components/universal/input/string/CodeInput.vue'
import PillButton from '@/components/universal/basic/PillButton.vue'

export default {
  name: 'ReferralPage',
  components: {
    PublicPageFrame,
    CodeInput,
    PillButton,
  },
  data() {
    return {
      CODE_LENGTH: 6,
      referralCode: '',
      referralCodeError: undefined,
    }
  },
  computed: {
    ...mapState('referral', [
      'referralInfo',
    ]),

    routeReferralCode() {
      return this.$route.params.referralCode || ''
    },
    imageSrc() {
      const { referrerUser = {} } = this.referralInfo || {}
      const { profilePhotoPath } = referrerUser
      const defaultImgPath = '/img/no_profile_photo.png'
      return profilePhotoPath || defaultImgPath
    },
  },
  watch: {
    routeReferralCode: {
      immediate: true,
      handler(newValue) {
        const uppercaseNewValue = newValue.toUpperCase()
        if (uppercaseNewValue !== this.referralCode) {
          this.referralCode = uppercaseNewValue
        }
      },
    },
    referralCode: {
      immediate: true,
      async handler(newValue) {
        this.referralCodeError = undefined
        if (newValue.length === this.CODE_LENGTH && newValue !== (this.referralInfo || {}).referralCode) {
          const isFromReferralLink = this.routeReferralCode === newValue
          this.$store.dispatch('analytics/LOG_EVENT', {
            name: 'referral_code_entered',
            data: {
              referralCode: newValue,
              isFromReferralLink,
            },
          })

          this.$router.replace({ name: 'referral', params: { referralCode: newValue } })
          const { success, error } = await this.$store.dispatch('referral/VALIDATE_REFERRAL', newValue)
          this.referralCodeError = error

          this.$store.dispatch('analytics/LOG_EVENT', {
            name: 'referral_validation_returned',
            data: {
              referralCode: newValue,
              isFromReferralLink,
              success,
              error,
            },
          })
        } else {
          this.$store.commit('referral/SET_REFERRAL_INFO', undefined)
        }
      },
    },
  },
  methods: {
    resetReferral() {
      this.$router.replace({ name: 'referralEntry' })
    },
    proceedToAuth() {
      this.$router.push({ name: 'auth' })

      const { referralCode } = this
      this.$store.dispatch('analytics/LOG_EVENT', {
        name: 'referral_confirmed',
        data: {
          referralCode,
        },
      })
    },
  },
  mounted() {
    const { routeReferralCode } = this
    this.$store.dispatch('analytics/LOG_EVENT', {
      name: 'referral_page_viewed',
      data: {
        referralCode: routeReferralCode,
      },
    })
  },
}
